// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"InitiateRefund_shimmer__2OLxV"};